<template>
  <div class="ucont">
    <vue-dropzone
      :key="this.msg"
      ref="myDropzone"
      id="dropzone"
      :options="{
        url: '/upload',
        // chunking: true,
        // retryChunks: true,
        maxFilesize: 100000,
        dictDefaultMessage: this.msg,
        complete: this.addFile
      }"
      ></vue-dropzone>
   </div>
</template>

<script>
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

export default {
  name: 'Uploader',
  components: {
    vueDropzone: vue2Dropzone
  },
  props: {
    msg: String
  },
  methods: {
    addFile (res) {
      this.$store.commit('addFile', {
        name: res.name,
        date: res.lastModified,
        size: res.size
      })
    }
  }
}
</script>

<style scoped>
.ucont {
  margin-bottom: 2em;
}
</style>
